<template>
	<div class='section-specifics'>

		<div class='grid'>
			<div :class='{ "not-match": !isMatch(values["is_water_protection_zone"]) }'>
				<custom-p-checkbox v-model='values["is_water_protection_zone"].value' label='Водоохранная зона' :disabled='!actLpoIsDraft'/>
			</div>
		</div>


		<div class='grid select-value-block'>

			<div :class='{ "not-match": !isMatch(values["ozu"]) }'>
				<span class='select-title'>ОЗУ</span>
				<custom-p-select
					v-model='values["ozu"].value'
					:options="info_ozu"
					:disabled='catalogsAreLoading || !actLpoIsDraft'
				/>
			</div>

			<div :class='{ "not-match": !isMatch(values["oopt"]) }'>
				<span class='select-title'>ООПТ</span>
				<custom-p-select
					v-model='values["oopt"].value'
					:options="info_oopt"
					:disabled='catalogsAreLoading || !actLpoIsDraft'
				/>
			</div>

		</div>

		<div class='not-match-block values-btn-row' v-if='notMatchingValues.length'>
			<div>
				<button @click='cancel'>Отмена</button>
				<button @click='save'>Сохранить</button>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex';

	export default {
		name: 'SectionSpecifics',
		data() {
			return {
				values: {
					is_water_protection_zone: {
						field: 'is_water_protection_zone',
						inputType: 'checkbox',
						value: false,
					},

					/*ozu_test: {
						field: 'ozu_id',
						inputType: 'select',
						value: [],
						catalog: 'info_ozu'
					},
					*/
					ozu: {
						field: 'ozu_id',
						inputType: 'select',
						value: null,
						catalog: 'info_ozu'
					},

					oopt: {
						field: 'oopt_id',
						inputType: 'select',
						value: null,
						catalog: 'info_oopt'
					}

				},

				catalogsAreLoading: false
			};
		},
		computed: {
			notMatchingValues() {
				const result = [];

				for (const value_name in this.values) {
					if (!this.isMatch(this.values[value_name])) {
						result.push(value_name);
					}
				}

				return result;
			},

			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			...mapState({
				lpo: state => state.selectedLpo.lpo,

				info_ozu: state => state.catalogs['info_ozu'],
				info_oopt: state => state.catalogs['info_oopt']
			})
		},
		methods: {
			save() {
				const valueList = [];

				for (const value_name of this.notMatchingValues) {
					const inputTypeIsSelect = this.values[value_name].inputType === 'select';

					const value = this.values[value_name].value;

					const temp = {
						field: this.values[value_name].field,
						value: value ? (inputTypeIsSelect ? value.id : value) : null
					};
					valueList.push(temp);
				}

				this.saveLpoValue(valueList).then(res => {
					return this.updateLpo();
				});
			},
			cancel() {
				this.resetValues();
			},

			resetValues() {
				for (let value_name in this.values) {
					const value = this.values[value_name];

					if (value.inputType === 'checkbox') {
						value.value = this.lpo[value.field] === 't';
					} else if (value.inputType === 'select') {

						const temp = this[value.catalog].find(item => {
							return item.id === this.lpo[value.field];
						});
						value.value = temp ? temp : null;

					} else if (value.inputType === 'input') {
						value.value = this.lpo[value.field];
					}
				}
			},
			
			isMatch(value) {
				if (this.catalogsAreLoading) {
					return true;
				}

				if (value.inputType === 'checkbox') {
					return value.value === (this.lpo[value.field] === 't');
				} else if (value.inputType === 'select') {
					if (!value.value) {
						return this.lpo[value.field] === null;
					} else {
						return value.value.id === this.lpo[value.field];
					}
				}

				return false;
			},

			...mapMutations([
				'addEmptyValueForCatalog'
			]),

			...mapActions('selectedLpo', [
				'saveLpoValue',
				'updateLpo',
			])
		},
		created() {
			const catalogs = [ 'info_ozu', 'info_oopt' ];

			this.catalogsAreLoading = true;
			this.$store.dispatch('loadCatalogs', catalogs).then(res => {

				this.addEmptyValueForCatalog('info_ozu');
				this.addEmptyValueForCatalog('info_oopt');

				this.catalogsAreLoading = false;
				this.resetValues();
			});
		}
	};
</script>

<style scoped src='@/style/grid.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>

	.p-dropdown {
		width: 100%;
	}

	.p-dropdown >>> .p-dropdown-label {
		overflow: visible;
		white-space: normal;
	}

	.p-dropdown >>> .p-dropdown-panel {
		width: 100%;
	}

	.p-dropdown >>> .p-dropdown-items-wrapper {
		width: 100%;
	}

	.p-dropdown >>> .p-dropdown-item {
		white-space: normal;
	}

	.not-match {
		background-color: orange;
	}

	.select-value-block {
		margin-top: 34px;
	}

	.select-title {
		font-weight: bold;
		display: inline-block;
		margin-bottom: 6px;
	}

</style>